//ui improvements by Anupama 

export function detectMob() {
    const toMatch = [
        /Android/i,
        /webOS/i,
        /iPhone/i,
        /iPad/i,
        /iPod/i,
        /BlackBerry/i,
        /Windows Phone/i
    ];

    return toMatch.some((toMatchItem) => {
        return navigator.userAgent.match(toMatchItem);
    });
  }
/**
 * Bug #588 - Native Bridge call for Login and logout   
 * @Modified by Jithin Kuriakose on 03Sept2021
 * */
export function detectMobileApp() {
    //console.log("navigator.userAgent ",navigator.userAgent);
    return navigator.userAgent.match(/HSPORTALAPP/i) || navigator.userAgent.match(/HSPORTALAPP-ANDROID/i);
  }
  //End Bug #588